import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { status } = useAuth();
    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[var(--bg-base)]">
                <span className="text-[var(--accent-champagne)] font-display text-2xl soft-pulse">
                    Loading…
                </span>
            </div>
        );
    }
    if (status !== "authed") {
        return <Navigate to="/admin" replace />;
    }
    return children;
}
